// A-024 Testkunde: Haken am Kunden und das Merkmal „TEST“ (Kunde, Belege, Buchungen) an EINER Stelle.
export const TestMarke = ({ titel = "Testkunde – zählt nicht echt", className = "", ...rest }) => (
  <span
    className={`inline-flex items-center px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-800 border border-amber-300 text-[10px] font-sans font-bold tracking-wide whitespace-nowrap ${className}`}
    title={titel}
    data-testid="marke-test"
    {...rest}
  >
    TEST
  </span>
);

export const TestkundeHaken = ({ wert, onChange, testId = "check-testkunde" }) => (
  <label className="flex items-start gap-2 rounded-sm border border-amber-200 bg-amber-50 p-2 text-xs cursor-pointer" data-testid="testkunde-feld">
    <input type="checkbox" className="mt-0.5 h-4 w-4 shrink-0" checked={!!wert} onChange={(e) => onChange(e.target.checked)} data-testid={testId} />
    <span>
      <span className="font-semibold text-amber-900">Testkunde – zählt nicht echt</span>
      <span className="block text-amber-900/80">
        Angebote, Auftragsbestätigungen, Rechnungen und Zahlungen dieses Kunden sind Übung: keine echte Nummer, zählen nirgends mit
        (Umsatz, Buchhaltung, Mahnwesen) und lassen sich jederzeit löschen. Bereits vorhandene Belege bleiben unverändert.
      </span>
    </span>
  </label>
);

// BUT-0019 (Ralph 23.10.2026): Kategorie „Testkunde“ und Haken sind EINE Angabe. Was sich gerade ändert, nimmt das
// andere mit (dieselbe Regel wie im Server, utils/testkunde.py). `liste` = Ralphs Kunden-Kategorien.
const istTestKategorie = (k) => typeof k === "string" && k.trim().toLowerCase() === "testkunde";
export const testkundeAbgleich = (alt, neu, liste = []) => {
  let kats = neu.categories || [];
  let haken = neu.testkunde === true;
  const katAlt = (alt.categories || []).some(istTestKategorie);
  const katNeu = kats.some(istTestKategorie);
  if (haken !== (alt.testkunde === true)) {
    const name = (liste || []).find(istTestKategorie);
    if (haken && !katNeu && name) kats = [...kats, name];
    if (!haken) kats = kats.filter((k) => !istTestKategorie(k));
  } else if (katNeu !== katAlt) {
    haken = katNeu;
  }
  return { ...neu, categories: kats, testkunde: haken };
};
